<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-body">
                <form [formGroup]="ResumeRecordsForm">
                    <div class="panel panel-default">
                        <header class="panel-heading">
                            <h5 class="panel-title">Create Resume</h5>
                        </header>
                    </div>

                    <div class="table-container">
                        <table mat-table [dataSource]="ResumeDataSource" style="width:100% !important">

                            <ng-container matColumnDef="EmployeeLPN">
                                <th mat-header-cell *matHeaderCellDef> Employee LPN </th>
                                <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;"> {{element.EmployeeLPN}} </td>
                            </ng-container>
                            <ng-container matColumnDef="EmployeeGPN">
                                <th mat-header-cell *matHeaderCellDef> Employee GPN </th>
                                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.EmployeeGPN}} </td>
                            </ng-container>
                            <ng-container matColumnDef="EmployeeName">
                                <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.EmployeeName}} </td>
                            </ng-container>
                            <ng-container matColumnDef="EmployeeEmail">
                                <th mat-header-cell *matHeaderCellDef> Employee Email </th>
                                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.EmployeeEmail}} </td>
                            </ng-container>
                            <ng-container matColumnDef="StatusDesc">
                                <th mat-header-cell *matHeaderCellDef> Resume Status </th>
                                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.StatusDesc}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer;"
                                (click)="ShowDetails(row)"></tr>
                        </table>
                    </div>

                    <div *ngIf="!recordsExists" style="text-align: center;">
                        <span style="color: red;">Record not found.</span>
                    </div>
                </form>
            </div>
        </div>
    </section>
</div>




